import React from "react";
import { Card, CardContent } from "@kuda/ui";
import { useMsal } from "@azure/msal-react";
import { UserIcon, EnvelopeIcon, BadgeCheckIcon, EtchUsersIcon } from "@kuda/ui/icons";

import Breadcrumbs from "./breadcrumbs";
import useUserAccount from "./hooks/userAccountInfo";
import ColoredAvatar from "./hooks/colorAvatar";

export default function UserInfo() {
  const { instance } = useMsal();
  // userAccountInfo now returns userRole and project derived from the roles array
  const { userName, userRole, project, nameParts } = useUserAccount(instance);

  const capitalizeWords = (str) =>
    str
      ? str.split(/[-_\s]/).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join(" ")
      : null;

  return (
    <div>
      <div className="pl-8 mb-4">
        <Breadcrumbs />
      </div>

      <div className="flex justify-center">
        <Card className="max-w-full">
          <div className="flex justify-center my-5">
            {nameParts?.length ? (
              <ColoredAvatar name={nameParts.join(" ")} size={100} />
            ) : null}
          </div>
          <CardContent>
            <h2 className="font-heading text-2xl font-bold mb-4">User Details</h2>

            <div className="flex flex-col gap-2 text-color-text-secondary">
              <div className="flex items-center gap-2">
                <UserIcon className="size-4" />
                <span>{nameParts?.[0]} {nameParts?.[1] || ""}</span>
              </div>

              <div className="flex items-center gap-2">
                <EnvelopeIcon className="size-4" />
                <span>{userName || null}</span>
              </div>

              {/* Effective system role */}
              <div className="flex items-center gap-2">
                <BadgeCheckIcon className="size-4" />
                <span>{userRole ? capitalizeWords(userRole) : null}</span>
              </div>

              {/* Project/team — only shown for non-admin roles */}
              {project && (
                <div className="flex items-center gap-2">
                  <EtchUsersIcon className="size-4" />
                  <span>{capitalizeWords(project)}</span>
                </div>
              )}
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
